/* eslint-disable @typescript-eslint/no-empty-interface, @typescript-eslint/no-misused-promises,
class-methods-use-this */
import React, { Component } from 'react';
import { confirmWrapper } from 'src/components/Dialog';
import { AxiosResponse } from 'axios';
import withRouter from '../../hooks/withRouter';

import {
  AddATSPropType,
  Skill,
  SkillFormSubmitHandler,
  SkillResponse,
  SkillsProps,
  SkillsState,
  SkillsViewRendererProps,
  UpdateATSPropType,
} from './types';
import API from '../../network';
import ViewRenderer from './views';
import { AddSkill } from './components';

class Skills extends Component
  <SkillsProps, SkillsState> {
  constructor(props: SkillsProps) {
    super(props);

    this.state = {
      skills: [],
      filterSkills: [],
      skillsFetching: true,
    };
  }

  componentDidMount() {
    this.getAllSkills();
  }

  getAllSkills = () => {
    this.setState(
      {
        skillsFetching: true,
        skills: [],
        filterSkills: [],
      },
      async () => {
        try {
          const response: AxiosResponse<SkillResponse[]> = await
          API.getInstance().fetchSkills();
          const eventsData: SkillResponse[] = response.data;
          this.setState({
            skills: eventsData,
            filterSkills: eventsData,
          });
        } catch (e) {
          await confirmWrapper('Something went wrong', {
            hideSecondaryBtn: true,
            variant: 'danger',
          });
        } finally {
          this.setState({
            skillsFetching: false,
          });
        }
      },
    );
  };

  onDeleteRow = async (data: Skill) => {
    const { value, id = 0 } = data;
    const deleteConfirmed = await confirmWrapper(`Are you sure want to delete ${value}?`, {
      variant: 'danger',
    });
    if (deleteConfirmed) {
      try {
        await API.getInstance().deleteATSProperties(id, 'SKILLS');
        await confirmWrapper('Skill deleted successfully!', {
          hideSecondaryBtn: true,
          variant: 'success',
          autoClose: true,
        });
        this.getAllSkills();
      } catch (e) {
        await confirmWrapper('Something went wrong', {
          hideSecondaryBtn: true,
          variant: 'danger',
        });
      } finally {
        this.setState({
          skillsFetching: false,
        });
      }
    }
  };

  createSkill = async (data: SkillFormSubmitHandler): Promise<void> => {
    const { values } = data;
    try {
      const request: AddATSPropType = {
        type: 'SKILLS',
        value: values?.value,
      };
      await API.getInstance().addATSProperty(request);
      this.getAllSkills();
    } catch (e: any) {
      await confirmWrapper(e?.response?.data.message || 'Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
      throw e;
    }
  };

  updateSkill = async (data: SkillFormSubmitHandler): Promise<void> => {
    const { values } = data;
    const { value, id } = values;
    const request: UpdateATSPropType = {
      id,
      type: 'SKILLS',
      value,
    };
    try {
      await API.getInstance().updateATSProperty(request);
      this.getAllSkills();
    } catch (e: any) {
      await confirmWrapper(e?.response?.data.message || 'Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
      throw e;
    }
  };

  showCreateSkill = async () => {
    await confirmWrapper('', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'dialogSmall',
      fullWidth: true,
      containerClasses: 'p-0',
      showCloseButton: true,
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent: <AddSkill
        disabled
        readOnly
        onCreateSkill={this.createSkill}
      />,
    });
  };

  onEditRow = async (data: Skill) => {
    await confirmWrapper('', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'dialogSmall',
      fullWidth: true,
      showCloseButton: true,
      containerClasses: 'p-0',
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent: <AddSkill
        defaultValues={data}
        disabled
        readOnly
        onCreateSkill={this.updateSkill}
      />,
    });
  };

  onChange = (searchString: string) => {
    const { skills } = this.state;
    const filteredObjects = skills.filter(({ value }) => value && value.toLowerCase()
      .includes(searchString.toLowerCase()));
    this.setState({
      filterSkills: filteredObjects,
    });
  };

  getProps = (): SkillsViewRendererProps => {
    const {
      skills,
      skillsFetching,
      filterSkills,
    } = this.state;

    return {
      skills,
      skillsFetching,
      filterSkills,
      showCreateSkill: this.showCreateSkill,
      onDeleteRow: this.onDeleteRow,
      onEditRow: this.onEditRow,
      onChange: this.onChange,
    };
  };

  render() {
    const viewProps: SkillsViewRendererProps = this.getProps();

    return (
      <ViewRenderer {...viewProps} />
    );
  }
}

export default withRouter(Skills);
